import { SECTIONS } from '../components/Sidebar/constants'
import {
  AUDITS,
  COMMUNICATIONS,
  CONSOLIDATIONS,
  CONTAINERS,
  DASHBOARD,
  LOCATIONS,
  MAIN,
  MANIFEST,
  OPERATIONS,
  PACKAGE_LOG,
  QR,
  ROUTES,
  SAVERS,
  TRIPS_LOG,
  USERS,
} from './paths'

export const cognitoGroups = {
  admin: 'admin',
  partner: 'partner',
  manager: 'manager',
  operations: 'operations',
  warehouse: 'warehouse',
  driver: 'driver',
  auditor: 'auditor',
  saver: 'saver',
}

export const connectPartnerAccessRoles = [
  cognitoGroups.admin,
  cognitoGroups.partner,
  cognitoGroups.manager,
]

export const MANAGER_PATHS = [
  MAIN,
  DASHBOARD,
  TRIPS_LOG,
  PACKAGE_LOG,
  USERS,
  QR,
  MANIFEST,
  OPERATIONS,
  COMMUNICATIONS,
  CONSOLIDATIONS,
  CONTAINERS,
  AUDITS,
  SAVERS,
  LOCATIONS,
  ROUTES,
]

export const MANAGER_SECTIONS = [
  SECTIONS.DASHBOARD,
  SECTIONS.DISPATCH,
  SECTIONS.INVENTORY,
  SECTIONS.ENTITIES,
  SECTIONS.TOOLS,
  SECTIONS.OPERATIONS,
]

export const OPERATIONS_PATHS = [
  MAIN,
  DASHBOARD,
  TRIPS_LOG,
  PACKAGE_LOG,
  USERS,
  QR,
  CONSOLIDATIONS,
  CONTAINERS,
  COMMUNICATIONS,
  AUDITS,
  SAVERS,
  ROUTES,
]

export const OPERATIONS_SECTIONS = [
  SECTIONS.DASHBOARD,
  SECTIONS.DISPATCH,
  SECTIONS.INVENTORY,
  SECTIONS.ENTITIES,
  SECTIONS.TOOLS,
]

export const WAREHOUSE_PATHS = [
  MAIN,
  DASHBOARD,
  TRIPS_LOG,
  PACKAGE_LOG,
  QR,
  CONSOLIDATIONS,
  CONTAINERS,
  USERS,
  COMMUNICATIONS,
  AUDITS,
  SAVERS,
  ROUTES,
]

export const WAREHOUSE_SECTIONS = [
  SECTIONS.DASHBOARD,
  SECTIONS.DISPATCH,
  SECTIONS.INVENTORY,
  SECTIONS.ENTITIES,
  SECTIONS.TOOLS,
]

export const AUDITOR_PATHS = [AUDITS, SAVERS]

export const AUDITOR_SECTIONS = [SECTIONS.TOOLS]

export const SAVER_PATHS = [AUDITS, SAVERS]

export const SAVER_SECTIONS = [SECTIONS.TOOLS]
